import router from '../../routes';

export default {
    state: () => ({
        filtered: [],
        types: [],
        retailers: [],
		categories: [],
		search: [],
		trendingTopLatest: 'Hot',
		isLoading: false,
        isFinished: false,
        page: 1,
    }),

    actions: {
        debounceDeals: _.debounce(async ({ dispatch }) => {
            await dispatch('getDeals');
        }, 400),


        async getDeals({ commit, state }, topFive = false) {
            state.isLoading = true;
            let categories = state.categories.filter(k=> k !== 'no');
            let ttl = router.app._route.query.type;

            const response = await window.axios.get('/api/deals/', {
                params: {
                    type: state.types,
                    retailers: state.retailers,
					categories,
					search: state.search,
					trendingTopLatest: ttl ? ttl : state.trendingTopLatest,
					topFive,
                    page: state.page,
                },
            });

            state.page = state.page + 1;
            const deals = [...state.filtered, ...response.data.data];

            if (response.data.data.length === 0) state.isFinished = true;

            commit('setDealData', deals);
            state.isLoading = false;
		},


		async toggleRetailersFilter({ commit }, retailerName) {
            commit('setRetailerFilter', retailerName);
            commit('resetDealsPagination');
        },

        async addRetailersFilter({ commit }, retailerName) {
            commit('addRetailerFilter', retailerName);
            commit('resetDealsPagination');
        },


        async toggleCategoriesFilter({ commit }, categories) {
            commit('setCategoryFilter', categories);
            commit('resetDealsPagination');
		},


		async setTrendingTopLatestFilter({ commit }, trendingTopLatest) {
            commit('setTrendingTopLatestFilter', trendingTopLatest);
            commit('resetDealsPagination');
            await this.dispatch('debounceDeals');
		},


		async searchFilter({ commit }, searchTerm) {
            commit('setSearchTerm', searchTerm);
            commit('resetDealsPagination');
        },

    },

    mutations: {
        setDealData(state, payload) {
            state.filtered = payload;
        },


        setTypeFilter(state, typeFilter) {
            state.types = typeFilter;
        },


        /**
         * Removes the retailer from the retailers array if they exist or add them (toggle)
         *
         * @param {*} state
         * @param {*} retailerName
         */
        setRetailerFilter(state, retailerName) {
            if (state.retailers.includes(retailerName)) {
                const indexOf = state.retailers.indexOf(retailerName);
                state.retailers.splice(indexOf, 1);
            } else {
                state.retailers.push(retailerName);
            }
        },

        
        addRetailerFilter(state, retailerName) {
            if (!state.retailers.includes(retailerName)) {
                state.retailers.push(retailerName);
            }
        },


        setCategoryFilter(state, categories) {
            state.categories = categories;
		},


		setTrendingTopLatestFilter(state, trendingTopLatest) {
            state.trendingTopLatest = trendingTopLatest;
		},


		setSearchTerm(state, searchTerm) {
			state.search = null; // Tell BE we don't have a search term
			if (searchTerm.length > 0) {
				state.search = [];
				state.search.push(`${searchTerm}`);
			}
        },

        resetRetailersFilter(state) {
            state.retailers = [];
        },

        resetCategoriesFilter(state) {
            state.categories = [];
        },

        resetDealsPagination(state) {
            state.filtered = [];
            state.page = 1;
            state.isFinished = false;
        },

        resetSearchFilter(state) {
            state.search = [];
        },

    },
};
